import React from 'react';
import logo from './logo.svg';
// import './App.css';
import {AppNonGridContainer} from './components/AppNonGridContainer';

function App() {
  return (
    <div className="App">
     <AppNonGridContainer></AppNonGridContainer>
    </div>
  );
}

export default App;
